module.exports = __webpack_public_path__ + "img/logo-28.563fb1a.jpg";